import { render } from "./CriarFerramentaCatalogo.vue?vue&type=template&id=937275e4&scoped=true"
import script from "./CriarFerramentaCatalogo.vue?vue&type=script&lang=js"
export * from "./CriarFerramentaCatalogo.vue?vue&type=script&lang=js"

import "./CriarFerramentaCatalogo.vue?vue&type=style&index=0&id=937275e4&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937275e4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QBtn,QImg,QFile,QField});
